<template>
<div class="week-data">
    <content-title :title="title"></content-title>
    <div class="div-table">
      <div class="table-head">
        <div class="null-block">
        </div>
        <div class="table-column" v-for="column in columns">
          {{column.leabel}}
        </div>
      </div>
      <div class="row-content" v-for="data in datas.slice(start_index, start_index + 15)">
        <div class="null-block">
          {{data.shop}}
        </div>
        <div class="table-data-block" v-for="(column, index) in columns">
          <div class="work-day" v-if="data.order_days.indexOf(index) > -1">
          </div>
        </div>
      </div>
    </div>
    <el-pagination small layout="prev, pager, next" v-on:current-change="pageChange" :page-size="15" :total="datas.length">
      </el-pagination>
  </div>
</template>

<script>
  import ContentTitle from '../components_bit/ContentTitle'
  export default {
    components: {
      'content-title': ContentTitle
    },
    data () {
      return {
        columns: [{
          leabel: '星期天'
        },
        {
          leabel: '星期一'
        },
        {
          leabel: '星期二'
        },
        {
          leabel: '星期三'
        },
        {
          leabel: '星期四'
        }],
        start_index: 0
      }
    },
    methods: {
      pageChange (currentPage) {
        this.start_index = (currentPage - 1) * 15
      }
    },
    props: ['datas', 'title']
  }
</script>

<style lang="less">
  .week-data {
    .el-pagination button {
      background-color: rgba(0, 0, 0, 0);
    }
    .el-pagination {
      padding-right: 1em;
      text-align: right;
    }
    .el-pager li {
      background-color: rgba(0, 0, 0, 0);
    }
    .el-pager li.active {
      background-color: #20a0ff;
    }
  }
</style>

<style scoped lang="less">
  @import '../style/base.less';
  .week-data {
    display: flex;
    background-color: #fff;
    flex:1;
    flex-direction:column;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
    padding-bottom: @content-border-radius-size;
    border-radius: @content-border-radius-size;
  }
  .div-table {
    padding: 0.625em;
    felx: 1;
    display: flex;
    flex-direction:column;
  }
  .table-head {
    height: 2.5em;
    display: flex;
    .table-column {
      border-bottom: 1px solid #999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
  }
  .row-content {
    border-right: 1px solid #999;
    display: flex;
    felx:1;
  }
  .null-block {
    display: flex;
    height: 2.5em;
    align-items: center;
    justify-content: center;
    width: 12em;
  }
  .table-data-block {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    border-left: 1px solid #999;
    flex: 1;
    height: 2.78em;
  }
  .work-day {
    height: 0.7em;
    width: 100%;
    background-color: #024162;
  }
</style>



// WEBPACK FOOTER //
// WeekData.vue?6ac751f6